module.exports = __webpack_public_path__ + "img/通知公告.7da43295.png";